import ColorDropdown from './code/Scripts/components/ColorDropdown.vue';
import ColorDropdownTreat from './code/Scripts/components/ColorDropdownTreat.vue';

export default {
  components: {
    ColorDropdown,
    ColorDropdownTreat,
  },
};
